/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkDeleteShiftsData
 */
export interface BulkDeleteShiftsData {
    /**
     * The ids of models to delete
     * @type {Array<number>}
     * @memberof BulkDeleteShiftsData
     */
    ids: Array<number>;
}

/**
 * Check if a given object implements the BulkDeleteShiftsData interface.
 */
export function instanceOfBulkDeleteShiftsData(value: object): value is BulkDeleteShiftsData {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function BulkDeleteShiftsDataFromJSON(json: any): BulkDeleteShiftsData {
    return BulkDeleteShiftsDataFromJSONTyped(json, false);
}

export function BulkDeleteShiftsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteShiftsData {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

  export function BulkDeleteShiftsDataToJSON(json: any): BulkDeleteShiftsData {
      return BulkDeleteShiftsDataToJSONTyped(json, false);
  }

  export function BulkDeleteShiftsDataToJSONTyped(value?: BulkDeleteShiftsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

